export const dirtyValuesFor = (currentValue, newValue) => {
  const dirtyValues = {};
  Object.keys(newValue).forEach((field) => {
    if (field !== 'id' && JSON.stringify(currentValue[field]) !== JSON.stringify(newValue[field])) {
      dirtyValues[field] = newValue[field];
    }
  });
  return dirtyValues;
};